import {
  Box,
  Flex,
  HStack,
  IconButton, 
  useDisclosure,
  useColorModeValue,
  Stack,
  Text
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { HashLink as Link} from 'react-router-hash-link';
export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Box id="nav-menu" bg={useColorModeValue('gray.800','gray.800')} px={4} position="fixed" top="0" z-index="2" width={'100%'}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={10} alignItems={'center'} color='whiteAlpha.900'>
            <Text fontWeight="700" fontSize={'xl'}>G Prasad Bhat</Text>
            <HStack
              as={'nav'}
              spacing={10}
              fontSize={'xl'}
              color='white'
              display={{ base: 'none', md: 'flex' }}>
                <Link to="#home">Home</Link>              
                <Link to="#about" smooth>About Me</Link>
                <Link to="#skills"  smooth>Skills</Link>
                <Link to="#project" smooth>Project</Link>
                <Link to="#contacts" smooth>Contact</Link>
                <a target="blank" href='https://drive.google.com/file/d/1vA3jSj2Kl88Em48SUx5LsYbeSh0MUkEg/view' >Resume</a>
            </HStack>
          </HStack>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack color='white' as={'nav'} spacing={4}>
                <Link to="#home" smooth>Home</Link>
                <Link to="#about" smooth>About Me</Link>              
                <Link to="#skills"  smooth>Skills</Link>
                <Link to="#project" smooth>Project</Link>
                <Link to="#contact" smooth>Contact</Link>
                <a target="blank" href='https://drive.google.com/file/d/1vA3jSj2Kl88Em48SUx5LsYbeSh0MUkEg/view'>Resume</a>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}